<ep-view [model]="viewModel">
  <h3>{{appStrings.homeDesc}}</h3>
</ep-view>